const STANDARD_BUCKET_PERCENTAGE = 21;
const GOOD_BUCKET_PERCENTAGE = 41;
const GREAT_BUCKET_PERCENTAGE = 61;
const BEST_BUCKET_PERCENTAGE = 81;

/**
 * This method on basis of number it returns value bucket
 * @param  {Number} valuePercentage
 * @return {Number}
 */
export function getValueBucket(valuePercentage) {
  if (valuePercentage <= STANDARD_BUCKET_PERCENTAGE - 1) {
    return {
      name: 'Value',
      value: 1,
    };
  } else if (valuePercentage >= STANDARD_BUCKET_PERCENTAGE && valuePercentage <= GOOD_BUCKET_PERCENTAGE - 1) {
    return {
      name: 'Value',
      value: 2,
    };
  } else if (valuePercentage >= GOOD_BUCKET_PERCENTAGE && valuePercentage <= GREAT_BUCKET_PERCENTAGE - 1) {
    return {
      name: 'GoodValue',
      value: 3,
    };
  } else if (valuePercentage >= GREAT_BUCKET_PERCENTAGE && valuePercentage <= BEST_BUCKET_PERCENTAGE - 1) {
    return {
      name: 'GreatValue',
      value: 4,
    };
  } else if (valuePercentage >= BEST_BUCKET_PERCENTAGE) {
    return {
      name: 'BestValue',
      value: 5,
    };
  }
}
